import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { MOBILE } from '../../../utils/constants';
import { usePathParam } from 'react-resource-router';
import PostAuthor from './PostAuthor';
import PostTags from './PostTags';
import PostActions from './PostActions';
import CommentsSection from './comments/CommentsSection';
import SuggestAnswer from './comments/SuggestAnswer';
import usePostById from 'hooks/ai-forums/usePostById';
// import { Renderer } from '~src/components/Editor/Renderer';
import { SummarizePost } from '../post-summarizer/SummarizePost';

const PostDetail = () => {
  const [slug] = usePathParam('slug');
  const { postDetailData } = usePostById(slug || '');

  if (!postDetailData) {
    return (
      <div css={errorStyles}>
        <h2>Post not found</h2>
        <p>Unable to load the requested post.</p>
      </div>
    );
  }

  return (
    <div css={containerStyles} data-testid="forum-post-slug">
      <article css={postStyles}>
        <h1 css={titleStyles}>{postDetailData.title}</h1>
        <div css={titleContainerStyles}>
          <PostAuthor
            avatar={postDetailData.author.avatar}
            name={postDetailData.author.name}
            badge={postDetailData.author.badge || undefined}
            timeAgo={postDetailData.author.timeAgo}
          />
          <SummarizePost postId={postDetailData.id} />
        </div>
        {/* <Renderer content={postDetailData.content} /> */}
        <PostTags tags={postDetailData.tags} hiddenTagsLabel="Hidden Tags" />
        <PostActions views={postDetailData.actions.views} likesInfo={postDetailData.actions.likesInfo} />
      </article>
      <SuggestAnswer postId={postDetailData.id} />
      <CommentsSection responses={postDetailData.responses || []} postId={postDetailData.id} />
    </div>
  );
};

const containerStyles = css({
  maxWidth: '800px',
  padding: '32px 0',
  margin: '0 auto',
  width: '100%',
  [MOBILE.MEDIA_QUERY]: {
    padding: '16px 0',
  },
});

const errorStyles = css({
  maxWidth: '800px',
  margin: '0 auto',
  padding: '32px',
  textAlign: 'center',
  color: token('color.text.danger'),
});

const postStyles = css({
  backgroundColor: token('elevation.surface'),
  border: `1px solid ${token('color.border')}`,
  borderRadius: '8px',
  padding: '32px',
  boxShadow: token('elevation.shadow.raised'),
  fontFamily: 'Charlie Text, sans-serif',
  [MOBILE.MEDIA_QUERY]: {
    padding: '16px',
  },
});

const titleStyles = css({
  fontSize: '32px',
  fontWeight: 700,
  color: token('color.text'),
  lineHeight: '1.2',
  margin: '0 0 24px 0',
  fontFamily: 'Charlie Display, sans-serif',
  [MOBILE.MEDIA_QUERY]: {
    fontSize: '24px',
    marginBottom: '16px',
  },
});

const titleContainerStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
});

export default PostDetail;
